// 22.01.19. This Saga combines all our Sagas.
import { all } from "redux-saga/effects";
import homeSaga from "./home";
import detailSaga from "./detail";
import userProfileSaga from "src/components/user-profile/sagas";

export default function* rootSaga() {
  yield all([homeSaga(), detailSaga(), userProfileSaga()]);
}
